import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchNote, restoreFromTrash } from "~/store/actions/actions.notes";
import { permanentlyDelete } from "~/store/actions/actions.trash";
import { getNoteById } from "~/store/selectors/selector.notes";
import { getLoggedUser } from "~/store/selectors/selector.users";

export const useNoteActions = (id, projectId) => {
  const dispatch = useDispatch();
  const note = useSelector((state) => getNoteById(state, id));
  const navigate = useNavigate();
  const loggedUser = useSelector(getLoggedUser);

  const handleRestore = useCallback(async () => {
    await dispatch(restoreFromTrash(id));
    await dispatch(fetchNote(projectId, id));
  }, [dispatch, id, projectId]);

  const handleDelete = useCallback(async () => {
    await dispatch(permanentlyDelete("Note", id));
    navigate(`/projects/${projectId}/notes`);
  }, [dispatch, navigate, id, projectId]);

  const canRestore = (note?.is_trashed && loggedUser.isOwner()) || note?.trashed_by_id === loggedUser.id;

  const canPermanentlyDelete = note?.is_trashed && loggedUser.class === "Owner";

  return {
    handleRestore,
    handleDelete,
    canRestore,
    canPermanentlyDelete,
  };
};
